import MenuComponent from '@/components/MenuComponent'

export default {
  components: {
    MenuComponent
  },
  methods: {
    getPdfFile () {
      var fileName = 'Politique-de-protection-des-donnees-personnelles-LCL-marche-des-Entreprises-hors-cookies.pdf'
      var hiddenElement = document.createElement('a')
      hiddenElement.href = '/' + this.$root.pdfLocation + '/' + fileName
      hiddenElement.target = '_blank'
      hiddenElement.setAttribute('download', fileName)
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
      document.body.removeChild(hiddenElement)
    }
  }
}
